import * as types from "../store/mutation-types";

export default {
    computed: {
        templates: {
            get() {
                return this.$store.getters.templates;
            },
            set(value) {
                this.$store.commit(types.SET_TEMPLATES, value);
            }
        },
        products: {
            get() {
                return this.$store.getters.products;
            },
            set(value) {
                this.$store.commit(types.SET_PRODUCTS, value);
            }
        },
        singleProducts: {
            get() {
                return this.$store.getters.singleProducts;
            },
            set(value) {
                this.$store.commit(types.SET_SINGLE_PRODUCTS, value);
            }
        },
        groupProducts: {
            get() {
                return this.$store.getters.groupProducts;
            },
            set(value) {
                this.$store.commit(types.SET_GROUP_PRODUCTS, value);
            }
        },
        tickets: {
            get() {
                return this.$store.getters.tickets;
            },
            set(value) {
                this.$store.commit(types.SET_TICKETS, value);
            }
        },
        discountCode: {
            get() {
                return this.$store.getters.discountCode;
            },
            set(value) {
                this.$store.commit(types.SET_DISCOUNT_CODE, value);
            }
        },
        currentStep: {
            get() {
                return this.$store.getters.currentStep;
            },
            set(value) {
                this.$store.commit(types.SET_CURRENT_STEP, value);
            }
        },

    }
};